import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileTabBar } from "./MobileTabBar";
import { SupportPill } from "./SupportPill";

export function SiteLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#1f222d]">
      <Header />
      <SupportPill />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileTabBar />
    </div>
  );
}
